import { capitaliseFirstLetter } from '../utils/capitalise-first-letter';
import { adjectives, nouns } from './word-lists';

export const GENERATED_USERNAME_PATTERN = /^[A-Z][a-z]+[A-Z][a-z]+\d{4}$/;

export function generateReadableUsername(): string {
  const adjectiveIndex = Math.floor(Math.random() * adjectives.length);
  const nounIndex = Math.floor(Math.random() * nouns.length);

  const adjective = capitaliseFirstLetter(adjectives[adjectiveIndex]);
  const noun = capitaliseFirstLetter(nouns[nounIndex]);

  const number = Math.floor(Math.random() * 9000) + 1000;

  return `${adjective}${noun}${number}`;
}
